import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import image1 from "../../../assets/advisory/steve.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography variant={"subtitle2"} fontWeight={700}>
        CEO
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "100%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            Steve Okeleji
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={{ xs: "50%", sm: "35%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.facebook.com/p/Okeleji-Steve-812194825/"
            title="Facebook"
          >
            <Avatar
              sx={{
                bgcolor: blue[900],
                width: 46,
                height: 46,
              }}
            >
              <FacebookIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.twitter.com/SOkeleji"
            title="Twitter"
          >
            <Avatar
              sx={{
                bgcolor: "#000",
                width: 46,
                height: 46,
              }}
            >
              <XIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.linkedin.com/in/steve-okeleji"
            title="LinkedIn"
          >
            <Avatar
              sx={{
                bgcolor: blue[700],
                width: 46,
                height: 46,
              }}
            >
              <LinkedInIcon />
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Grid container marginTop={{ xs: "10%", sm: "2%" }}>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "50vh", sm: "350px" }}
            paddingBottom={{ xs: "7%", sm: "0%" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
          <Box bgcolor={"#000058"} marginBottom={{ xs: "7%", sm: "0%" }}>
            <Typography padding={"6%"} color={"#fff"} variant="h6">
              "I believe Africa is capable of feeding the world and that our
              continent is the next frontier of economic development. Eight
              years after founding Fish Shoal Nigeria, I’m using my knowledge
              and experience to help drive change in Africa and make aquaculture
              accessible to fellow Africans.” - Steve Okeleji
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
          >
            Steve Okeleji was born to a veterinarian father who managed a large
            integrated commercial farm in Ondo State, Nigeria. Steve’s lifelong
            experience in aquaculture and fisheries began with this early
            exposure to commercial agriculture. His personal journey in
            aquaculture took off in 2006, during his second year of studying
            Aquaculture and Fisheries Management at the Federal University of
            Agriculture in Ogun State, Nigeria, when he founded Fish Shoal
            Nigeria. Currently a scholar at the Netherlands Business School,
            Steve was recognized by the World Bank in 2017 as a Young
            Aquaculture Innovator for his groundbreaking work in Africa. In
            2018, the International Food Policy Research Institute (IFPRI) in
            Washington, D.C., featured him as a case study for aquaculture
            development in Africa. In 2021, African Impact awarded him “African
            Champion for the Year in Agricultural Development” in Accra, Ghana.
            Steve also serves as a member of the United Nations Private Sector
            Advisory Group.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            Steve is a visionary leader committed to transforming blue food
            systems with a strong focus on sustainability, innovation, and
            community empowerment. Through his extensive work in aquaculture and
            fisheries, he has promoted sustainable management of aquatic
            resources, addressing food security, economic development, and
            environmental conservation.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "2%" }}
          paddingTop={{ xs: "0.5%", sm: "0%" }}
        >
          <Typography variant="body1" color={"#4f4f4f"} paragraph>
            A hallmark of Steve’s career is his dedication to empowering women
            in the blue economy. Recognizing their vital roles across the
            fisheries and aquaculture sectors—from fish farming to processing
            and marketing—he has implemented programs that equip women with
            training, financial resources, and access to technology. These
            efforts have substantially improved livelihoods in coastal and rural
            communities, positioning women as key contributors to local
            economies. By integrating women into the blue food value chain,
            Steve not only promotes gender equality but also fosters resilient,
            inclusive food systems.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            Steve’s work is also characterized by his innovative approach to
            aquaculture, where he has pioneered sustainable practices that
            reduce environmental impact while enhancing productivity. Notably,
            he has developed eco-friendly technologies like integrated
            multi-trophic aquaculture (IMTA) systems, which reduce waste and
            boost biodiversity in aquatic farming. His sustainable aquaculture
            initiatives set a benchmark for balancing environmental
            responsibility with economic growth.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            Through collaborations with governments, NGOs, and local
            communities, Steve Okeleji continues to shape policies and raise
            awareness on the importance of healthy oceans and waterways. His
            leadership in promoting sustainable blue food systems has earned him
            global recognition as a champion for aquaculture, climate action,
            and food security.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
